import { ClientImportationsRepository } from "@domain/repositories/ClientImportationsRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";
import { ClientImportation } from "@domain/models/ClientImportation";

type Input = Client["id"];

type Output = Promise<ClientImportation[]>;

export class GetClientImportationsUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientImportationsRepository: ClientImportationsRepository) {}

  execute(clientId: Input) {
    return this.clientImportationsRepository.getClientImportations(clientId);
  }
}
